import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Clear from '@material-ui/icons/Clear';
import { Btn } from '../../components/global';
import { Username, Password, TextInput } from '../../components/textInput';
import { legacyLogin, migrate, getUsername } from "../../APIs"
import { legacyLogin_styles } from "./styles";

export default withStyles(legacyLogin_styles)((props) => {
    const {
        classes,
        onSignInSuccess,
        onSignInError,
        onClose
    } = props;
    const legacyServices = [
        {_id: "M_REPORT", name: "M report"},
        // {_id: "ONLINE_ORDER", name: "Online Order"}
    ]
    const [selectedService, selectService] = useState(legacyServices[0]._id);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const hashCode = function(email) {
        var hash = 0, i, chr;
        if (email.length === 0) return hash;
        for (i = 0; i < email.length; i++) {
          chr   = email.charCodeAt(i);
          hash  = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    const generateUsername = (email) => {
        let username = "MGRT-";
        username += Math.round(Math.random()*1000);
        const hash = hashCode(email);
        username += hash;
        return username;
    }

    const signInHandler = async () => {
        try {
            setLoading(true);
            let username;
            const usernameQuery = await getUsername(email);
            if (usernameQuery.data.registered) {
                username = usernameQuery.data.username
            } else {
                username = generateUsername(email);
            }
            const loginRes = await legacyLogin(username, email, password, selectedService);
            const { token } = loginRes.data;
            await migrate(selectedService, token);
            onSignInSuccess(email, password);
            setLoading(false);
        } catch(err) {
            alert("The combination of username and password is not correct.")
            setLoading(false);
        }
    }

    return (
        <div className={classes.root}>
            <div className={classes.close}>
                <Clear onClick={() => onClose()}/>
            </div>
            <div className={classes.smMargin}>I have an account on...</div>
            <CustomTextField select
                className={classes.mdMargin}
                variant="outlined"
                value={selectedService}
                onChange={(ev) => selectService(ev.target.value)}
            >
                {legacyServices.map(option => (
                    <MenuItem key={option._id} value={option._id}>
                        {option.name}
                    </MenuItem>
                ))}
            </CustomTextField>
            <div className={classes.smMargin}>Login with above product's account</div>
            <CustomTextField label={"email"}
                className={classes.smMargin}
                onChange={(ev) => { setEmail(ev.target.value) }}
                onKeyDown={(e) => { 
                    if (e.keyCode == 13) {
                        signInHandler();
                    }
                }}/>
            <div key={"password"} 
                className={classes.lgMargin}>
                <Password label={"password"}
                    onChange={(ev) => { setPassword(ev.target.value) }}
                    onKeyDown={(e) => { 
                        if (e.keyCode == 13) {
                            signInHandler();
                        }
                    }}/>
            </div>
            <Btn variant="contained" 
                    color="primary"
                    className={classes.button}
                    onClick={signInHandler}
            >
                {"Login"}
            </Btn>
        </div>
    );
})

const CustomTextField = (props) => (
    <TextField
        style={{width: '100%'}}
        variant="outlined"
        {...props}
    >
        {props.children}
    </TextField>
)